import data from "./data.json";

export const QUESTION_IS_RANDOM = data.QUESTION_IS_RANDOM;
export const QUESTION_START_WITH = data.QUESTION_START_WITH;
export const QUESTION_END_WITH = data.QUESTION_END_WITH;
export const GAME_DURATION = data.GAME_DURATION;
export const questions = data.questions;
export const questions_en = data.questions_en;
export const questions_sc = data.questions_sc;
